"use client";

import type { Footer as FooterType } from "@/payload-types";
import { cn } from "@/lib/utils";
import { CTAButtonLink } from "@/components/shared/CTAButtonLink";
import { RichText } from "@/components/RichText";
import { BlockContainer } from "@/components/shared/BlockContainer";

interface FooterBannerProps {
  footer: FooterType;
}

export function FooterBanner({ footer }: FooterBannerProps) {
  const { bannerHeading, bannerDescription, bannerButton } = footer;

  // Don't render if no content
  if (!bannerHeading && !bannerDescription) return null;

  return (
    <div className="bg-brand">
      <BlockContainer>
        <div
          className={cn(
            "w-full text-left p-8 md:p-12",
            "bg-brand",
            "flex flex-col md:flex-row md:items-center md:justify-between gap-6 md:gap-8"
          )}
        >
        {/* Content: Heading and Description side by side on desktop */}
        <div className="flex-1 flex flex-col md:flex-row md:items-end gap-4 md:gap-6">
          {/* Banner Heading */}
          {bannerHeading && (
            <h2 className="font-subheading text-2xl md:text-3xl lg:text-4xl 2xl:text-5xl text-white md:flex-shrink-0">
              {bannerHeading}
            </h2>
          )}

          {/* Banner Description */}
          {bannerDescription && (
            <RichText
              content={bannerDescription}
              className="rich-text-lg rich-text-dark"
            />
          )}
        </div>

        {/* Banner Button */}
        {bannerButton?.label && bannerButton?.link && (
          <div className="flex-shrink-0">
            <CTAButtonLink
              label={bannerButton.label}
              type={bannerButton.link.type || "custom"}
              page={
                typeof bannerButton.link.page === "object"
                  ? bannerButton.link.page
                  : undefined
              }
              url={bannerButton.link.url || undefined}
              newTab={bannerButton.link.newTab || false}
              className="min-w-[180px]"
            />
          </div>
        )}
      </div>
    </BlockContainer>
    </div>
  );
}
